import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseCodeInput } from '../components/base-code-input/component.js';
import 'classnames';
import '../components/input/component.js';

var styles = {"component":"code-input__component_1uivw","compact":"code-input__compact_1uivw"};
require('./mobile.css');

var CodeInputMobile = forwardRef(function (restProps, ref) { return React.createElement(BaseCodeInput, __assign({}, restProps, { ref: ref, stylesInput: styles })); });

export { CodeInputMobile };
